<form class="page-container flex" (validate)="generateCertificate()" validation-es novalidate>
  <article class="col-12 md:col-6 py-0 pl-0 inline-flex flex-column">
    <h2 class="col-12 px-0 py-0 form__field">
      {{screen.labels.patientInformation}}
    </h2>

    <div class="col-12 px-0 py-0 form__field">
      <label for="document">{{screen.labels.document}}</label>
      <span>
        <input pInputText [(ngModel)]="certificateInformation.document" name="document"
          [placeholder]="screen.labels.documentPlaceholder" class="uppercase" autocomplete="off" validation
          [required]="true" />
      </span>
    </div>

    <div class="col-12 px-0 py-0 form__field">
      <label class="field__label field__label--required">{{screen.labels.fullName}}</label>
      <span class="inline-flex">
        <span class="col-12 py-0 pl-0">
          <input pInputText [(ngModel)]="certificateInformation.names" name="names"
            [placeholder]="screen.labels.firstName" class="uppercase" autocomplete="off" validation [required]="true" />
        </span>
      </span>
    </div>
    <div class="col-12 px-0 py-0 form__field">
      <span class="inline-flex">
        <span class="col-12 py-0 pl-0">
          <input pInputText [(ngModel)]="certificateInformation.lastnames" name="lastnames"
            [placeholder]="screen.labels.firstLastname" class="uppercase" autocomplete="off" validation
            [required]="true" />
        </span>
      </span>
    </div>

    <div class="col-12 px-0 py-0 form__field align-items-center flex-row">
      <label class="no-margin" for="dateBorn">{{screen.labels.dateBorn}}</label>
      <span [style.margin-left.px]="10">
        <dx-date-box name="dateBorn" [value]="certificateInformation.born!"
          [placeholder]="screen.labels.datePlaceholder" (onValueChanged)="setBornDate($event)"
          [displayFormat]="screen.labels.dateFormatFull" type="date">
        </dx-date-box>
      </span>
    </div>

    <hr>

    <h2 class="col-12 px-0 py-0 form__field">
      {{screen.labels.medicalInformation}}
    </h2>

    <div class="col-12 px-0 py-0 form__field align-items-center flex-row">
      <label class="no-margin" for="attendance">{{screen.labels.dateAttendance}}</label>
      <span [style.margin-left.px]="10">
        <dx-date-box name="attendance" [value]="certificateInformation.attendance!"
          [placeholder]="screen.labels.datePlaceholder" (onValueChanged)="setAttendanceDate($event)"
          [displayFormat]="screen.labels.dateFormatFull" type="date">
        </dx-date-box>
      </span>
    </div>

    <div class="col-12 px-0 py-0 form__field">
      <label for="autocomplete-cie">
        {{screen.labels.cie}}
        <i class="fas fa-info-circle cie-info" *ngIf="certificateInformation.cie"
          pTooltip="[{{certificateInformation.cie!.id}}] - {{certificateInformation.cie!.description}}" appendTo="body"
          [style.margin-left.px]="5"></i>
      </label>
      <span class="ui-g-12 ui-lg-10">
        <p-autoComplete name="autocomplete-cie" [(ngModel)]="certificateInformation.cie" [minLength]="3"
          [placeholder]="screen.labels.ciePlaceholder" dataKey="id" [forceSelection]="true" field="displayName"
          [suggestions]="cieSuggestions" (completeMethod)="completeSuggestions($event.query)"
          styleClass="ellipsis uppercase" validation [required]="true">
        </p-autoComplete>
      </span>
    </div>

    <div class="col-12 px-0 py-0 form__field">
      <label for="medicalRestRange">{{screen.labels.medicalRestDateRange}}</label>
      <div class="inline-flex">
        <span class="col-fixed py-0 pl-0 align-self-center" [style.width.px]="20">
          <p-checkbox name="hasMedicalRest" [(ngModel)]="hasMedicalRest" [binary]="true"
            (ngModelChange)="clearMedicalRestInformation()"></p-checkbox>
        </span>
        <span class="col py-0 pr-0">
          <p-calendar #medicalRestRange name="medicalRestRange" [(ngModel)]="medicalRestDateRange"
            (ngModelChange)="medicalRestDateSelected()" [touchUI]="true" selectionMode="range" [readonlyInput]="true"
            [showIcon]="true" [placeholder]="screen.labels.medicalRestDateRangePlaceholder"
            [dateFormat]="screen.labels.dateFormat" [rangeSeparator]="screen.labels.rangeDateSeparator"
            [disabled]="!hasMedicalRest" [keepInvalid]="true" validation [required]="hasMedicalRest" appendTo="body">
          </p-calendar>
        </span>
      </div>

    </div>

    <div class="col-12 px-0 py-0 form__field">
      <label for="doctorFullname">{{screen.labels.doctor}}</label>
      <div class="inline-flex">
        <span class="col-4 py-0 pl-0">
          <input pInputText [(ngModel)]="certificateInformation.doctorPrefix" name="doctorPrefix"
            [placeholder]="screen.labels.doctorPrefixPlaceholder" class="uppercase" autocomplete="off" />
        </span>
        <span class="col-8 py-0 pr-0">
          <input pInputText [(ngModel)]="certificateInformation.doctorFullName" name="doctorFullname"
            [placeholder]="screen.labels.fullName" class="uppercase" autocomplete="off" validation [required]="true" />
        </span>
      </div>
    </div>

    <div class="col-12 px-0 py-0 form__field">
      <label for="doctorSpecialty">{{screen.labels.doctorSpecialty}}</label>
      <span>
        <input pInputText [(ngModel)]="certificateInformation.doctorSpecialty" name="doctorSpecialty"
          [placeholder]="screen.labels.doctorSpecialtyPlaceholder" class="uppercase" autocomplete="off" validation
          [required]="true" />
      </span>
    </div>

    <div class="align-self-end">
      <button pButton [type]="loading ? 'button' : 'submit'" [label]="screen.actions.generate"
        [icon]="loading ? loadingIcon : 'far fa-file-pdf'" iconPos="left"
        class="p-button-success p-button-outlined"></button>
    </div>
  </article>

  <article class="col-6 py-0 pr-0 preview-section hide-on-small">
    <section class="document-preview">
      <div class="flex flex-column">
        <span class="align-self-end">
          Quito, {{today | date:screen.labels.dateFormatLong}}
        </span>

        <h2 class="align-self-center">
          Certificado Médico
        </h2>

        <span [style.margin-top.px]="20">
          Certifico que el/la paciente: <span class="strong uppercase">{{certificateInformation.names}}
            {{certificateInformation.lastnames}}</span> de <span
            class="strong uppercase">{{certificateInformation.age}}</span> de edad, con documento de
          identidad Nº <span class="strong">{{certificateInformation.document}}</span>, fue atendido en Von Development
          Studio el {{certificateInformation.attendance | date:screen.labels.dateFormatLong}}
        </span>

        <span [style.margin-top.px]="20">
          El diagónstico de salud por el cual fue atendido es: <span *ngIf="certificateInformation.cie"
            class="strong">{{certificateInformation.cie!.displayName}}</span>
        </span>

        <span *ngIf="certificateInformation.medicalRestQuantity! > 0" [style.margin-top.px]="40">
          Por lo que requiere un reposo de (<span class="strong">{{certificateInformation.medicalRestQuantity}}</span>)
          día{{certificateInformation.medicalRestQuantity! > 1 ? 's' : ''}}<span
            *ngIf="certificateInformation.medicalRestQuantity! > 1">,
            del {{certificateInformation.medicalRestStartDate | date:screen.labels.dateFormatLong}}
            al {{certificateInformation.medicalRestEndDate | date:screen.labels.dateFormatLong}}</span>
        </span>

        <span class="capitalize" [style.margin-top.px]="80">
          {{certificateInformation.doctorPrefix}} {{certificateInformation.doctorFullName}}
        </span>
        <span class="capitalize" [style.margin-top.px]="20">
          {{certificateInformation.doctorSpecialty}}
        </span>
      </div>
    </section>
  </article>

  <ms-pdf-viewer [(pdfFile)]="reportFile" [(show)]="showReportFile"></ms-pdf-viewer>
</form>